import { render, staticRenderFns } from "./SysUpdateList.vue?vue&type=template&id=276c6cf4&scoped=true"
import script from "./SysUpdateList.vue?vue&type=script&lang=js"
export * from "./SysUpdateList.vue?vue&type=script&lang=js"
import style0 from "./SysUpdateList.vue?vue&type=style&index=0&id=276c6cf4&prod&scoped=true&lang=css"
import style1 from "./SysUpdateList.vue?vue&type=style&index=1&id=276c6cf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276c6cf4",
  null
  
)

export default component.exports